import React, { useContext } from "react";
import styled from "styled-components";
import { UserContext } from "./UserContext";
import { NavLink as Link } from "react-router-dom";
const Sidebar = () => {
  const [user, setUser] = useContext(UserContext);
  const logout = () => {
    setUser({ role: "unauthenticated" });
  };
  return (
    <Container>
      <LogoContainer>
        <img src="/logo.png" alt="logo" />
      </LogoContainer>
      {user.role === "user" && (
        <>
          <CardContainer to="/user/home">Home</CardContainer>
          <CardContainer to="/user/transactions">Transactions</CardContainer>
          <CardContainer to="/user/transfer">Transfer</CardContainer>
          <CardContainer to="/" onClick={logout}>
            Logout
          </CardContainer>
        </>
      )}
      {user.role === "admin" && (
        <>
          <CardContainer to="/admin/home">Home</CardContainer>
          <CardContainer to="/admin/users">Users</CardContainer>
          <CardContainer to="/admin/transfer">Credit/Debit</CardContainer>
          <CardContainer to="/" onClick={logout}>
            Logout
          </CardContainer>
        </>
      )}
      {user.role === "unauthenticated" && (
        <>
          <CardContainer to="/">Home</CardContainer>
        </>
      )}
    </Container>
  );
};
const Container = styled.div`
  height: 100vh;
  width: 15%;
  background-color: #fff;
  box-shadow: 1px 1px 4px #ddd;
`;
const CardContainer = styled(Link)`
  display: block;
  text-decoration: none;
  background-color: #f5642f;
  color: white;
  font-size: 1.1rem;
  font-weight: 500;
  margin: 1em 0 1em 1em;
  padding: 1em;
  border-radius: 4px 0 0 4px;
  border-left: 6px solid #c03502;
  cursor: pointer;
  transition: margin 0.3s;
  :hover {
    margin-left: 0.8em;
  }
`;
const LogoContainer = styled.div`
  width: 100px;
  height: 100px;
  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
  }
`;
export default Sidebar;
